import { useEffect } from "react";

// Bridge forwarder. Community Lounge redirects the browser here
// (…/sso/callback?token=…) after it authenticates the user. We hand off to the
// backend /api/sso/callback, which verifies the token with CL, sets the session
// cookie, and redirects into the app with a #token fragment. Using this thin
// frontend route lets the redirect_uri be the clean "/sso/callback" on any host.
export default function SsoCallback() {
  useEffect(() => {
    const qs = window.location.search || "";
    window.location.replace(`/api/sso/callback${qs}`);
  }, []);
  return (
    <div
      className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6"
      data-testid="sso-callback-page"
    >
      <div className="text-[var(--ff-text-dim)] font-mono-ui text-sm uppercase tracking-[0.2em] animate-pulse">
        Signing you in…
      </div>
    </div>
  );
}
